import request from '../utils/request'

export function modifyEmployee(employee) {
    return request({
        url: '/api/employee/modify',
        method: 'post',
        data: employee
    })
}


export function deleteEmployee(employeeId) {
    return request({
        url: '/api/com/delete',
        params: {
            table: 'sys_employee',
            id: employeeId
        }
    })
}